import React from 'react';
import { injectIntl } from 'react-intl';

import styles from '../styles/components/logoText.module.scss';

const LogoText = ({ intl }) => {
  const currentLanguage = intl.locale;
  let logoText = (
    <span className={styles.es}>
      M<span>anos</span> S<span>in</span>
      <br />F<span>ronteras</span>
      <br />Int<span>ernacional</span>
    </span>
  );

  if (currentLanguage === 'pt') {
    logoText = (
      <span className={styles.pt}>
        M<span>ãos</span> S<span>em</span>
        <br />F<span>ronteiras</span>
        <br />Int<span>ernacional</span>
      </span>
    );
  }

  return (
    <div>
      { logoText }
    </div>
  );
};

export default injectIntl(LogoText);
